const addressMap = {
    //Static
    '0x0000000000000000000000000000000000000000': 'Null: 0x0000000000000000000000000000000000000000',

    // Node
    '0xc958d9c03353b477abc1a7cb4aefc13ed39f8c8e': 'AGD Validator 1',
    '0xf84f693565f5a1b5384b908f54027a71fa2e37b5': 'AGD Validator 2',
    '0x7dec1d4866313caf651bc395a367003a6f3f4cb9': 'Vietnam Blockchain Corporation',

    '0xceb6b88d6ca568d134ab32d4592f606c3a308684': 'Vibi Validator',

    // Contract
    '0x2b66a4028841a85cffd5449bd3cba4480ca28c9e': 'AGD DI Genie',
    '0x363a251ab72c602cb83a98c53918b16b1cdf7f27': 'AGD DA Genie',
    '0x9235bc9ce51b3079d0672329b6522a4742f21f3a': 'Agridential.vn DIG',
    '0x24e42fe49f4a4492dcb8e67c83b65f2479865e74': 'Agridential.vn DAG'
}

const useAddressMap = () => {
    const getAddressName = address => {
        return addressMap[address.toLowerCase()] || ''
    }

    return { getAddressName }
}

module.exports = { useAddressMap }
